import AuthService from "./auth/auth.service.js";
import GraphService from "./auth/graph.service.js";
import graphConfig from "./auth/graphConfig.js";
import Loader from "../components/Loader.vue";
import LoggedInUser from "../components/LoggedInUser.vue";
import LandingView from "../components/LandingView.vue";
import TenantDialog from "../components/TenantDialog.vue";
import MessageSheet from "../components/MessageSheet";
import ChangePassword from "../components/ChangePassword";
import GlobalSearchText from "../components/search/GlobalSearchText";
import Vue from "vue";
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import JumpToMeeting from "@/components/agenda/JumpToMeeting.vue";
import AppHeader from "@/components/header/AppHeader.vue";
import AppFooter from "@/wrapper-component/AppFooter.vue";
import TenantSwitchDialog from "@/components/TenantSwitchDialog.vue";
import SignalRMixin from "../mixin/SignalRMixin";
import { createUUID } from "../utils/util.js";
import userAuthService from "../api/userAuthorizationService";
import tenantConfigService from "../api/tenantConfigService";

Vue.prototype.$eventHub = new Vue();
export default {
  components: {
    Loader,
    LoggedInUser,
    LandingView,
    TenantDialog,
    MessageSheet,
    ChangePassword,
    GlobalSearchText,
    JumpToMeeting,
    AppHeader,
    AppFooter,
    TenantSwitchDialog,
  }, //Code to be uncommented
  mixins: [SignalRMixin],
  data: () => ({
    routeTenantIdWatch: null,
    selectedTenant: null,
    changePasswordDialog: false,
    displayMessage: false,
    messageType: "",
    message: "",
    isTenantSelect: false,
    showTenantDialog: false,
    drawer: null,
    mobileMenu: false,
    Contacts: [],
    selectedLocale: {
      value: "ja",
      text: "日本語",
      iconSrc: require("../assets/images/JP.png"),
    },
    langs: [
      {
        value: "en",
        text: "English",
        iconSrc: require("../assets/images/EngUS.png"),
      },
      {
        value: "ja",
        text: "日本語",
        iconSrc: require("../assets/images/JP.png"),
      },
    ],
    right: null,
    user: null,
    userInfo: null,
    apiCallFailed: false,
    loginFailed: false,
    profilePhoto: null,
    userFullName: null,
    tenantItems: [],
    tenantMenu: false,
  }),
  async created() {
    this.$eventHub.$on("globalSearchLoader", this.globalSearchLoader);
  },
  beforeDestroy() {
    this.$eventHub.$off("globalSearchLoader");
  },
  async mounted() {
    sessionStorage.setItem("isTenantSwitch", false);
    if (!sessionStorage.getItem("tenantId")) {
      sessionStorage.setItem("tenantId", localStorage.getItem("tenantId"));
    }
    let tenant = sessionStorage.getItem("tenantId");
    tenant = tenant ? tenant : localStorage.getItem("tenantId");
    const temp = localStorage.getItem("SelectedLocale#" + tenant);
    if (temp) {
      this.selectedLocale = JSON.parse(temp);
    }
    //this.$i18n.locale = this.selectedLocale.value;
    this.setLang(this.selectedLocale);
    this.createUniqueTabId();
  },
  watch: {
    user: async function () {
      if (this.user) {
        await this.fetchUserInformation();
        this.profilePhoto = await this.graphService.getPhotoSmall();
      }
    },
    $route(value) {
      try {
        this.$nextTick(async () => {
          if (value) {
            if (
              this.$security.checkUserAccess("ViewUsers") &&
              sessionStorage.getItem("tenantId")
            ) {
              if (this.defaultTemplateList?.length === 0) {
                await this.getDefaultEmailTemplates();
              }
              await this.getCachedUserList();
            }
          }
          await this.updateTenantSwitchData()
        });
      } catch (error) {
        console.log(error, "api error");
      }
    },
    "$route.params.tenantId": {
      immediate: true,
      async handler(newValue, oldValue) {
        if (newValue) {
          this.$nextTick(async () => {
            this.showTenantDialog = false;
            this.selectedTenant = this.tenantItems.find(
              (t) => t.id === sessionStorage.getItem("tenantId")
            );
            await this.signalRInit();
          });
        }
      },
    },

    "$auth.user": {
      immediate: true,
      async handler(newValue, oldValue) {
        if (newValue && newValue.email) {
          this.showTenantDialog = false;
          this.tenantItems =
            this.$auth.user[process.env.VUE_APP_TENANT_KEY] || [];
          const { tenantId } = this.$route.params;
          const { tenant } = this.$route.query;
          const actualTenantId = tenantId || tenant;
          this.signalRTenantGroup(`admin_tenant_group_update`);
          if (!actualTenantId) {
            if (!sessionStorage.getItem("tenantId")) {
              sessionStorage.setItem(
                "tenantId",
                localStorage.getItem("tenantId")
              );
            }
            const isExist = this.tenantItems.some(
              (t) => t.id === sessionStorage.getItem("tenantId")
            );
            if (isExist) {
              this.selectedTenant = this.tenantItems.find(
                (t) => t.id === sessionStorage.getItem("tenantId")
              );
              this.showTenantDialog = !this.selectedTenant;
              await this.signalRInit();
              await this.signalRConfigInit(`tenant_config_${this.selectedTenant.id}`);
              // this.tenantName = this.selectedTenant ? this.selectedTenant.name : '';
            } else {
              this.showTenantDialog = true;
              this.selectedTenant = null;
            }
          }
        }
      },
    },
    "$auth.permissions": {
      immediate: true,
      async handler(newValue, oldValue) {
        const routePath = this.$route.path;
        const path = routePath.replace(/\//g, "");
        let module = "";
        if (path == "dashboard") {
          module = "ViewDashboard";
        } else if (path == "agenda") {
          module = "ViewAgenda";
        } else if (path == "calendar") {
          module = "ViewCalendar";
        } else if (path == "people") {
          module = "ViewPeople";
        } else if (path == "documents") {
          module = "ViewDocuments";
        } else if (path == "survey") {
          module = "ViewSurveyPolls";
        } else if (path == "admin") {
          module = "ViewAdmin";
        } else if (path == "activitylogs") {
          module = "ViewActivityLogs";
        } else if (path == "task") {
          module = "ViewTask";
        } else if (path == "statistics&analysis") {
          module = "ViewMeetingStatistics";
        }
        if (
          path &&
          path.length > 0 &&
          module &&
          module.length > 0 &&
          !newValue.includes(module)
        ) {
          this.$router.push({ path: "/" });
        }
      },
    },
    isAPIError(value) {
      if (value) {
        this.showMessageSheet(
          "For assistance, please contact the administrator.",
          "error"
        );
        this.setAPIErrorStatus(false);
      }
    },
    isAPIErrorMsg(value) {
      if (value) {
        this.showMessageSheet(value, "info");
        this.setAPIErrorMessage(null);
      }
    },
    isAPIErrorKey(errorObj) {
      let errorType = "info";
      if (errorObj && errorObj.errorType) {
        errorType = errorObj.errorType;
      }
      if (errorObj && errorObj.key && errorObj.missing_columns) {
        let translatedCols;
        if (errorObj.key == "MissingColumns" && Array.isArray(errorObj.missing_columns)) {
          translatedCols = errorObj.missing_columns.map(col => this.$t(`lcaMissingColumns.${col}`))
        }
        this.showMessageSheet(this.$t(errorObj.key, { "MissingColumns": translatedCols.join(", ") }), errorType);
      } else if (errorObj && errorObj.key === "invalidColumnCount") {
        this.showMessageSheet(
          this.$t(`lcaErrors.${errorObj.key}`, { columns: errorObj.column_count }),
          errorType
        );
      } else if (errorObj && errorObj.key) {
        this.showMessageSheet(this.$t(errorObj.key), errorType);
        this.setAPIErrorKey(null);
      }
    },
  },
  computed: {
    ...mapState({
      isAPIError: (state) => state.isAPIError,
      isAPIErrorMsg: (state) => state.isAPIErrorMsg,
      isAPIErrorKey: (state) => state.isAPIErrorKey,
      defaultTemplateList: (state) => state.tenant.defaultTemplateList,
    }),
    ...mapGetters({
      tenantSettingTypes: "tenant/tenantSettingTypes",
    }),
    LoaderText() {
      return this.$t("LoaderText");
    },
    tenantName() {
      if (sessionStorage.getItem("tenantId")) {
        const tenants =
          this.$auth.user[process.env.VUE_APP_TENANT_KEY] || [];
        this.selectedTenant = tenants.find(
          (t) => t.id === sessionStorage.getItem("tenantId")
        );
        return this.selectedTenant ? this.selectedTenant.name : "";
      }
      return ""
    },
    items() {
      let menuItems = [];
      if (this.isPermissions) {
        menuItems = [
          { title: "menu.home", icon: "mdi-home", path: "/" },
          {
            title: "menu.dashboard",
            icon: "mdi-view-dashboard",
            path: "/dashboard",
          },
          { title: "menu.agenda", icon: "mdi-calendar-text", path: "/agenda" },
          {
            title: "menu.calendar",
            icon: "mdi-calendar-month",
            path: "/calendar",
          },
          {
            title: "menu.stockAnalysis",
            icon: "mdi-finance",
            path: "/stockanalysis",
          },
          { title: "menu.corporateValueAnalytics", icon: "mdi-chart-bar", path: "/CVAnalytics" },
          { title: "menu.businessPerformance", icon: "mdi-chart-bar", path: "/BusinessPerformance" },
          { title: "menu.businessManagement", icon: "mdi-chart-line-variant", path: "/BusinessManagement" },
          { title: "menu.people", icon: "mdi-account-group", path: "/people" },
          {
            title: "menu.documents",
            icon: "mdi-file-document-multiple",
            path: "/documents",
          },
          // { title: "menu.communication", icon: "mdi-chat", path: "/communications" },
          { title: "menu.survey", icon: "mdi-poll", path: "/survey" },
          { title: "task.lblTask", icon: "mdi-book-edit", path: "/task" },
          { title: "menu.admin", icon: "mdi-account-cog", path: "/admin" },
          {
            title: "menu.statistics&Analysis",
            icon: "mdi-chart-pie",
            path: "/statistics&analysis",
          },
          {
            title: "menu.activitylogs",
            icon: "mdi-history",
            path: "/activitylogs",
          },
        ];
      } else {
        menuItems = [
        ];
      }
      return menuItems.filter((item) => {
        const route = this.$security.ctx.router.options.routes.find(r => r.path === item.path);
        const hideMenu = route?.meta?.hideMenu;
      
        return !hideMenu && this.$security.canAccessRoute(item.path);
      });
      
    },
    isAuthenticated() {
      return this.$auth.isAuthenticated;
    },
    isPermissions() {
      return Boolean(this.$auth.permissions.length);
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    currentPathName() {
      return this.$route.name;
    },
    timerPage() {
      return (
        this.$route.path.startsWith("/meetingTimer/") ||
        this.$route.path.startsWith("/usermanual") ||
        this.$route.path.startsWith("/licensepolicy") ||
        this.$route.path.startsWith("/sessionexpired")
      );
    },
    helpOptions() {
      return [
        // {
        //   value: "productUpdate",
        //   text: "Product Update",
        //   icon: "mdi-update",
        //   href: "/productupdate"
        // },
        {
          value: "userManual",
          text: this.$t("UserManual"),
          icon: "mdi-account-question",
          href: "/usermanual",
        },
        {
          value: "writeToUs",
          text: this.$t("WriteToUs"),
          icon: "mdi-email-edit-outline",
          href: "mailto:avantboard@avantcorp.com",
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      getCachedUserList: "people/getCachedUserList",
      getTenantConfigList: "tenant/getTenantConfigList",
      resetAdminState: "admin/resetState",
      resetAgendaState: "agenda/resetState",
      resetDirectoryState: "directory/resetState",
      resetDocumentState: "document/resetState",
      resetMeetingState: "meeting/resetState",
      resetNewsState: "news/resetState",
      resetPeopleState: "people/resetState",
      resetPollState: "poll/resetState",
      resetSearchState: "search/resetState",
      resetStockState: "stock/resetState",
      resetTaskState: "task/resetState",
      resetTenantState: "tenant/resetState",
      resetTimerState: "timer/resetState",
      resetTranscriptionState: "transcription/resetState",
      resetVariablesState: "variables/resetState",
      resetWidgetState: "widget/resetState",
      getDefaultEmailTemplates: "tenant/getDefaultEmailTemplates",
      setTenantGroupData: "admin/setTenantGroupData"
    }),
    ...mapMutations({
      setAPIErrorMessage: "setAPIErrorMessage",
      setAPIErrorKey: "setAPIErrorKey",
      setAPIErrorStatus: "setAPIErrorStatus",
      setSwitchTenantId: "setSwitchTenantId",
    }),
    resetStates() {
      this.resetAdminState();
      this.resetAgendaState();
      this.resetDirectoryState();
      this.resetDocumentState();
      this.resetMeetingState();
      this.resetNewsState();
      this.resetPeopleState();
      this.resetPollState();
      this.resetSearchState();
      this.resetStockState();
      this.resetTaskState();
      this.resetTenantState();
      this.resetTimerState();
      this.resetTranscriptionState();
      this.resetVariablesState();
      this.resetWidgetState();
    },
    globalSearchLoader(flag) {
      if (flag) {
        this.$loader.show();
      } else {
        this.$loader.hide();
      }
    },
    alertClose() {
      this.$store.commit("setAlert", null);
    },
    navbarRightClick(itemId) {
      if (this.$refs.refNavList) {
        setTimeout(() => {
          let listElement = document.getElementById(itemId);
          listElement.blur();
        }, 100);
      }
    },
    getNavigationInfo(item) {
      const title = this.$t(item.title);

      switch (title) {
        case this.$t("menu.home"):
          return this.$t("tipHomePage");
        case this.$t("menu.dashboard"):
          return this.$t("tipDashboardPage");
        case this.$t("menu.agenda"):
          return this.$t("tipAgendaPage");
        case this.$t("menu.calendar"):
          return this.$t("tipCalendarPage");
        case this.$t("menu.stockAnalysis"):
          return this.$t("tipStockAnalysis");
        case this.$t("menu.businessPerformance"):
          return this.$t("tipBusinessPerformance");
        case this.$t("menu.businessManagement"):
          return this.$t("tipBusinessManagement");
        case this.$t("menu.people"):
          return this.$t("tipPeoplePage");
        case this.$t("menu.documents"):
          return this.$t("tipDocumentPage");
        case this.$t("menu.survey"):
          return this.$t("tipSurveyPollPage");
        case this.$t("menu.admin"):
          return this.$t("tipAdminPage");
        case this.$t("menu.statistics&Analysis"):
          return this.$t("tipstatistics&Analysis");
        case this.$t("menu.activitylogs"):
          return this.$t("tipActivitylogsPage");
        case this.$t("menu.aboutus"):
          return this.$t("tipAboutUsPage");
        case this.$t("task.lblTask"):
          return this.$t("task.lblTaskTip");
        default:
          return title;
      }
    },
    async onTenatChange(value) {
      // this.tenantName = this.selectedTenant ? this.selectedTenant.name : '';
      if (this.$route.path === "/forbidden" || this.$route.path !== "/") {
        this.setSwitchTenantId(this.selectedTenant.id);
        this.$router.push({ path: "/" });
      } else {
        sessionStorage.setItem("tenantId", this.selectedTenant.id);
        localStorage.setItem("tenantId", this.selectedTenant.id);
        this.$router.go();
      }
    },
    onChangePassword() {
      this.changePasswordDialog = true;
    },
    setLang(lang) {
      if (this.$i18n.locale !== lang.value) {
        this.selectedLocale = Object.assign({}, lang);
        const loc = JSON.stringify(this.selectedLocale);
        const tenant = sessionStorage.getItem("tenantId");
        localStorage.setItem("SelectedLocale#" + tenant, loc);
        this.$i18n.locale = lang.value;
      }
    },
    async getContactList(Url) {
      await this.authService.getToken().then((token) => {
        axios(Url, {
          headers: {
            Authorization: "Bearer " + token.accessToken,
          },
        })
          .then((response) => {
            this.Contacts = [...this.Contacts, ...response.data.value];
            if (response.data["@odata.nextLink"]) {
              //alert("Next Link :- " + response.data["@odata.nextLink"]);
              this.getContactList(response.data["@odata.nextLink"]);
            } else {
              this.filterContacts(this.Contacts).then((res) => {
                this.$store.commit("StoreContacts", res);
              });
            }
          })
          .catch((e) => {
            console.log(e);
          });
      });
    },
    async filterContacts(Contacts) {
      this.Contacts = await Contacts.filter((x) => !!x.userPrincipalName);
      return this.Contacts;
    },
    async fetchUserInformation() {
      await this.graphService.GetUserInformation().then((res) => {
        this.userInfo = res;
        this.userFullName =
          this.userInfo.givenName + " " + this.userInfo.surname;
      });
    },
    logout() {
      //this.authService.logout();
      this.$auth.logout();
      this.$router.push({ path: "/" });
    },
    loginWithAuth0() {
      this.$auth.getTokenWithPopup().then(async (response) => {
        await userAuthService.setActivityLog("login")
        this.$router.go();
      });
    },
    login() {
      this.loginFailed = false;
      this.authService.login().then(
        (user) => {
          if (user) {
            this.user = user;
          } else {
            console.log("login failed" + user);
            this.loginFailed = true;
          }
        },
        () => {
          this.loginFailed = true;
        }
      );
    },
    onHelpOptionClick(option) {
      if (option.value !== "writeToUs") {
        //this.$router.push(option.href);
        this.openUserManual(option.href);
      } else {
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = option.href;
        a.click();
      }
    },
    openUserManual(path) {
      var height = screen.height;
      var width = screen.width;
      var strWindowFeatures =
        "location=no,toolbar=no,menubar=no,height=" +
        height +
        ",width=" +
        width +
        ",scrollbars=auto,fullscreen=yes";
      let routeData = this.$router.resolve({
        path: path,
      });
      var popup = window.open(routeData.href, "_blank", strWindowFeatures);
      popup.moveTo(0, 0);
    },
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    openWebsite() {
      window.open("https://www.avantcorp.com");
    },
    async signalRInit() {
      try {
        const selectedTenantId = sessionStorage.getItem("tenantId");
        if (selectedTenantId) {
          let target = `admin_${selectedTenantId}`;
          this.signalConnection.off(target, this.signalrTarget);
          this.signalConnection.on(target, this.signalrTarget);
          if (
            this.signalConnection.connectionState.toLowerCase() ===
            "disconnected"
          ) {
            this.signalConnection.start().catch();
          }
        }
      } catch (error) {
        console.warn(error);
      }
    },
    async signalrTarget(message) {
      const result = JSON.parse(message);
      if (result) {
        if (result.role && result.role_type && this.$auth.roles_data) {
          const meetingTypeRoles = this.$auth.roles_data.meeting_type_roles.map(
            (t) => t.role_id
          );
          if (
            this.$auth.roles_data.general_roles.includes(result.id) ||
            meetingTypeRoles.includes(result.id)
          ) {
            await this.$auth.loadPermissions(this.$auth.user.email);
          }
        }
        if (
          result.firstName &&
          result.registered_email &&
          result.registered_email.length > 0 &&
          result.registered_email == this.$auth.user.email
        ) {
          if (result.is_deleted == true) {
            this.$auth.logout();
          } else {
            await this.$auth.loadPermissions(this.$auth.user.email);
          }
        }
        if (this.$auth.user.email === result.registered_email) {
          this.$auth.user.name = `${result.firstName} ${result.lastName}`;
        }
        await this.$auth.updateUserPermissionsDetails();
        await this.$auth.updateTenantListWithHistory();
      }
    },
    createUniqueTabId() {
      let uuid = sessionStorage.getItem("tab_id");
      if (!uuid) {
        sessionStorage.setItem("tab_id", createUUID());
      }
    },
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    onMenuClick(path) {
      const externalPaths = ["/CVAnalytics"];
      const isExternalPath = externalPaths.includes(path);

      if (isExternalPath) {
        this.handleExternalPath(path);
      } else {
        if (this.$router.currentRoute.path !== path) {
          this.$router.push({ path });
        }
      }
    },
    handleExternalPath(path) {
      const urls = this.tenantSettingTypes("investorRelationshipURLs");
      const urlKey = path.slice(1);

      if (urls?.length) {
        const url = getValueByKey(urls, urlKey);
        if (url) {
          window.open(url, '_blank');
        } else {
          console.warn(`URL not found for key: ${urlKey}`);
        }
      } else {
        console.warn("No URLs found in tenant settings.");
      }
    },
    async updateTenantSwitchData() {
      const isSwitch = sessionStorage.getItem("isTenantSwitch");
      if (isSwitch === "true") {
        this.resetStates();
        await userAuthService.setActivityLog("login");
        await this.$auth.loadPermissions(this.$auth.user.email);
        await this.getTenantConfigList(true);
        await this.getCachedUserList(true);
        sessionStorage.setItem("isTenantSwitch", false);
      }
    },
    signalRConfigInit,
    signalRTenantGroup
  }
};

function signalRTenantGroup(target) {
  this.signalConnection.on(target, async (response) => {
    if (response) {
      try {
        const { user_id, ...data } = response
        if (this.$auth.user.sub === user_id) {
          const companyTitles = await tenantConfigService.getTenantNamesHistory();
          const tenantList = await this.$auth.addDisplayNames(data.tenants, companyTitles)
          const updateTenants = { ...data, tenants: tenantList };
          this.setTenantGroupData(updateTenants)
        }
      } catch (error) {
        console.log(error, "API error");
      }
    }
  });
  if (this.signalConnection.connectionState.toLowerCase() === "disconnected") {
    this.signalConnection.start().catch();
  }
}

async function signalRConfigInit(target) {
  await this.signalConnection.on(target, async (message) => {
    const config_name = message.config_name || "";
    if (config_name === "email_templates" || config_name === "anonymity_feedback") {
      await this.getTenantConfigList(true);
    }
  });
  if (this.signalConnection.connectionState.toLowerCase() === "disconnected") {
    this.signalConnection.start().catch();
  }
}

function getValueByKey(data, key) {
  for (let obj of data) {
    if (obj.hasOwnProperty(key)) {
      return obj[key];
    }
  }
  return null;  // Return null if the key is not found
}
